import { DraftConfiguration, PrintType, SizePx } from '@/types';
import { convertSizePxToSizeMm } from '@/model/configuration/convertSize';
import { isDraftSpecialTextConfiguration } from '@/model/configuration/isDraftConfigurationType';
import { isPixelDraftConfiguration } from '@/model/configuration/isPixelDraftConfiguration';
import { scaleSize } from '@/model/configuration/scaleSize';
import { convertColors } from '@/model/printType/convertColors';

export function changePrintType(
  configuration: DraftConfiguration,
  printType: PrintType,
  updateScale = true
) {
  const currentDpi = configuration.printType.dpi;
  const nextDpi = printType.dpi;

  // if the new print type has a different dpi we need to recalculate the base size of the configuration
  if (currentDpi !== nextDpi && isPixelDraftConfiguration(configuration)) {
    const sizePx = isDraftSpecialTextConfiguration(configuration)
      ? configuration.task.size
      : configuration.processedSize || (configuration.design.size as SizePx);
    const currentSize = configuration.size;
    const nextSize = convertSizePxToSizeMm(sizePx, printType);
    configuration.size = nextSize;

    // if the scale was not already calculated by the previous step (e.g. product type / print area switch)
    //  we want to update the scale so the size of the configuration stays the same
    if (updateScale) {
      const currentScale = configuration.scale;
      const nextScale = (currentScale * nextDpi) / currentDpi;

      // if we cannot match the current size because the new print type has more DPI we want to center it at least
      if (nextScale > 1) {
        configuration.scale = 1;

        const currentScaledSize = scaleSize(currentSize, currentScale);
        configuration.offset.x += (currentScaledSize.width - nextSize.width) / 2;
        configuration.offset.y += (currentScaledSize.height - nextSize.height) / 2;
      } else {
        configuration.scale = nextScale;
      }
    }
  }

  configuration.printType = printType;
  configuration.printColors = convertColors(printType, configuration.printColors);
}
